import { setVar } from '../functions';

export const setAutoBikeTimerDB = props => {
  console.log('setTimer pro Autônomo', props);
  const dateNow = new Date().getTime();

  setVar({
    args: {},
    pass: {
      keyPath: ['sc.B4.currData.checkout.timer.initTimeStamp'],
      value: dateNow,
    },
  });

  // DENTRO DE PREPARE DATA
  //   sc.B4...timer.isRunning === "true" // Está sendo feito Via Cápsula
  //   condição (if)
  // IF locationType === Autônomo
  // timer.isRuning
  // setVar({
  //   args: {},
  //   pass: {
  //     keyPath: ['sc.B4.currData.checkout.timer.isRunning'],
  //     value: "true",
  //   },
  // });
};
